import { render, staticRenderFns } from "./Accueil_Message_Important.vue?vue&type=template&id=84b38ebc&scoped=true&"
import script from "./Accueil_Message_Important.vue?vue&type=script&lang=js&"
export * from "./Accueil_Message_Important.vue?vue&type=script&lang=js&"
import style0 from "./Accueil_Message_Important.vue?vue&type=style&index=0&id=84b38ebc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b38ebc",
  null
  
)

export default component.exports